import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, unref as _unref, renderList as _renderList, createTextVNode as _createTextVNode, withKeys as _withKeys, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "notification-row" }
const _hoisted_2 = {
  key: 0,
  class: "notification-row__check"
}
const _hoisted_3 = { class: "notification-item" }
const _hoisted_4 = { class: "notification-item__header" }
const _hoisted_5 = { class: "notification-item__header-workers" }
const _hoisted_6 = { class: "notification-item__header-divider" }
const _hoisted_7 = { class: "notification-item__header-options" }
const _hoisted_8 = {
  key: 0,
  class: "notification-item__actions"
}
const _hoisted_9 = { class: "notification-item__body" }
const _hoisted_10 = ["innerHTML"]
const _hoisted_11 = {
  key: 1,
  class: "notification-item__additions"
}
const _hoisted_12 = { class: "notification-item__addition-header" }
const _hoisted_13 = { class: "notification-item__addition-user" }
const _hoisted_14 = { class: "notification-item__addition-date" }
const _hoisted_15 = { class: "notification-item__addition-message" }
const _hoisted_16 = { class: "notification-item__addition-title" }
const _hoisted_17 = ["innerHTML"]
const _hoisted_18 = { class: "notification-item__comment-label" }
const _hoisted_19 = { class: "notification-item__comment-input" }
const _hoisted_20 = {
  key: 3,
  class: "notification-item__body-project"
}
const _hoisted_21 = { class: "notification-item__body-project-text" }
const _hoisted_22 = {
  key: 4,
  class: "notification-item__body-project"
}
const _hoisted_23 = { class: "notification-item__body-project-text" }
const _hoisted_24 = {
  key: 0,
  class: "notification-item__body-project-divider"
}
const _hoisted_25 = { class: "notification-item__footer-bottom" }
const _hoisted_26 = { class: "notification-item__footer-bottom-created" }

import {
	computed,
	ref
} from "vue"
import { useRoute } from "vue-router"
import AppIcon from "@/components/ui-kit/icon/AppIcon.vue"
import AppLoader from "@/components/common/AppLoader.vue"
import AppCheckbox from "@/components/ui-kit/checkbox/AppCheckbox.vue"
import AppCustomTextarea from "@/components/ui-kit/textarea/AppCustomTextarea.vue"
import AppTooltip from "@/components/ui-kit/tooltip/AppTooltip.vue"
import JobInfoModal from "@/components/main/jobs-panel/modals/JobInfoModal.vue"
import { requestJobHighlight } from "@/components/file/jobNavigation"
import NotificationUndoOverlay from "./NotificationUndoOverlay.vue"
import { JobNotification } from "@/ api/NotificationsApi"
import { JobStatus } from "@/models/etc/types"
import { workerStore } from "@/store/worker"
import { jobsStore } from "@/store/jobs"
import { headerStore, JobNotificationAction } from "@/store/header"
import { multilineTextToHtml, trimTrailingLineBreaks } from "@/utils/textHelpers"
import { useMessageSendingWay } from "@/composables/useMessageSendingWay"
import { i18n } from "@/i18n"

type Props = {
	notification: JobNotification
	showMoveAction?: boolean
}


export default /*@__PURE__*/_defineComponent({
  __name: 'NotificationItem',
  props: {
    notification: {},
    showMoveAction: { type: Boolean, default: false }
  },
  emits: ["move-to-history", "navigate"],
  setup(__props: any, { expose: __expose, emit: __emit }) {

const t = (key: string, named?: Record<string, unknown>): string => String(named ? i18n.global.t(key, named) : i18n.global.t(key))

const props = __props

const emit = __emit

const route = useRoute()
const worker = workerStore()
const header = headerStore()
const { newLineMode, sendHintKey } = useMessageSendingWay()

const $jobInfoModal = ref<InstanceType<typeof JobInfoModal> | null>(null)
const $commentTextarea = ref<InstanceType<typeof AppCustomTextarea> | null>(null)

const isLoading = ref(false)
const showCommentInput = ref(false)
const commentMessage = ref('')
const pendingAction = ref<JobNotificationAction | null>(null)
// Комментарии пока всегда развёрнуты
// Попросят вернуть — вернуть false
const additionsExpanded = ref(true)
const isClientsExpanded = ref(false)

const displayedClients = computed(() =>
	isClientsExpanded.value || !props.notification.Clients
		? props.notification.Clients
		: props.notification.Clients.slice(0, 1)
)

const userId = computed(() => worker.workerProfile?.Id)
const isAdmin = computed(() => worker.workerProfile?.IsAdmin ?? false)
const isCreator = computed(() => props.notification.Creator?.Id === userId.value)
const isWorker = computed(() => props.notification.Worker?.Id === userId.value)

const showCreatorName = computed(() =>
	!!props.notification.Creator && props.notification.Creator.Id !== props.notification.Worker?.Id
)

const isWorkingOrLost = computed(() =>
	props.notification.Status === JobStatus.Working || props.notification.Status === JobStatus.Lost
)
const isWaitingForCheck = computed(() =>
	props.notification.Status === JobStatus.WaitingForCheck
)

const showSendToChecking = computed(() =>
	!showCommentInput.value && isWorkingOrLost.value && isWorker.value && !isCreator.value && props.notification.NeedChecking
)
const showEndByWorkerNoMessage = computed(() =>
	!showCommentInput.value && isWorkingOrLost.value && isWorker.value && !isCreator.value && !props.notification.NeedChecking
)
const showSelfWorkerWithReport = computed(() =>
	!showCommentInput.value && isWorkingOrLost.value && isWorker.value && isCreator.value && props.notification.NeedChecking
)
const showSelfWorkerNoReport = computed(() =>
	!showCommentInput.value && isWorkingOrLost.value && isWorker.value && isCreator.value && !props.notification.NeedChecking
)
const showCreatorChecking = computed(() =>
	!showCommentInput.value && isWaitingForCheck.value && isCreator.value && !isWorker.value
)
const showAdminEnd = computed(() =>
	!showCommentInput.value && isAdmin.value && !isCreator.value && !isWorker.value
	&& (isWorkingOrLost.value || isWaitingForCheck.value)
)
const showAdminEndExtra = computed(() => {
	if (showCommentInput.value || !isAdmin.value) return false
	if (isWorkingOrLost.value && isWorker.value && !isCreator.value && props.notification.NeedChecking) return true
	if (isWorkingOrLost.value && isCreator.value && !isWorker.value) return true
	if (isWaitingForCheck.value && isWorker.value && !isCreator.value && props.notification.NeedChecking) return true
	return false
})

const hasActionButtons = computed(() =>
	showSendToChecking.value || showEndByWorkerNoMessage.value || showSelfWorkerWithReport.value
	|| showSelfWorkerNoReport.value || showCreatorChecking.value || showAdminEnd.value
	|| showAdminEndExtra.value
)

const commentLabel = computed(() => {
	switch (pendingAction.value) {
		case 'endByWorker': return t('job_comment_label_finish') + ':'
		case 'sendToChecking': return t('job_comment_label_report') + ':'
		case 'sendToReworking': return t('job_action_rework') + ':'
		case 'endByAdmin': return t('job_comment_label_finish') + ':'
		default: return ''
	}
})

const getJobStatusBarColor = (status: number) => {
	switch (status) {
		case JobStatus.Standard: return "#9A9C9E"
		case JobStatus.Working: return "#86CED2"
		case JobStatus.WaitingForCheck: return "#FFE7AA"
		case JobStatus.Completed: return "#6DA279"
		case JobStatus.Lost: return "#EE966A"
		default: return "#9A9C9E"
	}
}

const formatDate = (date?: string | null) => {
	if (!date) return ""
	const dateObj = new Date(date)
	return dateObj.toLocaleDateString("ru-RU", {
		day: "2-digit",
		month: "2-digit",
		year: "2-digit"
	})
}
// Время в формате "чч:мм" — рисуется перед датой создания
const formatTime = (date?: string | null) => {
	if (!date) {
		return ""
	}

	const dateObj = new Date(date)
	const hours = String(dateObj.getHours()).padStart(2, '0')
	const minutes = String(dateObj.getMinutes()).padStart(2, '0')
	return `${hours}:${minutes}`
}
const formatDateTime = (date?: string | null) => {
	if (!date) return ""
	const dateObj = new Date(date)
	const hours = String(dateObj.getHours()).padStart(2, '0')
	const minutes = String(dateObj.getMinutes()).padStart(2, '0')
	const day = String(dateObj.getDate()).padStart(2, '0')
	const month = String(dateObj.getMonth() + 1).padStart(2, '0')
	const year = dateObj.getFullYear()
	return `${hours}:${minutes} ${day}.${month}.${year}`
}

const dateTooltip = computed(() => {
	if (props.notification.Status !== JobStatus.Completed) {
		return t('job_deadline')
	}
	return props.notification.Lost
		? t('job_overdue_at', { date: formatDate(props.notification.ToDoDate) })
		: t('job_completed_on_time')
})

const showUserJobs = (id?: number) => {
	if (id == null) return
	jobsStore().setUserForUpdateJobsList(id)
}

const startAction = (action: JobNotificationAction) => {
	showCommentInput.value = true
	pendingAction.value = action
	commentMessage.value = ''
}

const cancelAction = () => {
	showCommentInput.value = false
	commentMessage.value = ''
	pendingAction.value = null
	$commentTextarea.value?.reset()
}

const directAction = async (action: JobNotificationAction) => {
	try {
		isLoading.value = true
		await header.applyJobAction(props.notification.JobId, action)
	} finally {
		isLoading.value = false
	}
}

const submitAction = async () => {
	if (!pendingAction.value || !commentMessage.value.trim()) return
	const message = trimTrailingLineBreaks(commentMessage.value)
		.replace(/\n/g, '<br/>')
	const action = pendingAction.value
	cancelAction()
	try {
		isLoading.value = true
		await header.applyJobAction(props.notification.JobId, action, message)
	} finally {
		isLoading.value = false
	}
}

const handleAdminEnd = () => {
	if (props.notification.NeedChecking) {
		startAction('endByAdmin')
	} else {
		directAction('endByAdmin')
	}
}

const handleShowInfo = () => {
	$jobInfoModal.value?.onOpen(props.notification.JobId)
}

const onEntityLinkClick = (event: MouseEvent, type: "client" | "project", entityId: number) => {
	if (requestJobHighlight(event, type, entityId, props.notification.JobId)) {
		emit('navigate')
	}
}

const isChecked = ref(false)
const $undoOverlay = ref<InstanceType<typeof NotificationUndoOverlay> | null>(null)

const onCheck = (val: boolean) => {
	if (!val) {
		return
	}
	isChecked.value = true
}

const onMoveCountdownFinish = () => {
	emit('move-to-history', props.notification.Id)
}

const onCancelMove = () => {
	isChecked.value = false
}

const flushPendingMove = () => {
	$undoOverlay.value?.flush()
}

__expose({ flushPendingMove })

const loaderStyle = { 'background-color': 'rgba(255, 255, 255, 0.5)' }

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(JobInfoModal, {
      ref_key: "$jobInfoModal",
      ref: $jobInfoModal,
      onNavigate: _cache[0] || (_cache[0] = ($event: any) => (emit('navigate')))
    }, null, 512),
    _createElementVNode("div", _hoisted_1, [
      (props.showMoveAction)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createVNode(AppTooltip, {
              text: _ctx.$t('notification_move_to_history'),
              disabled: isChecked.value
            }, {
              activator: _withCtx(() => [
                _createVNode(AppCheckbox, {
                  shape: "round",
                  value: isChecked.value,
                  disabled: isChecked.value,
                  "onUpdate:value": onCheck
                }, null, 8, ["value", "disabled"])
              ]),
              _: 1
            }, 8, ["text", "disabled"])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_3, [
        (isLoading.value)
          ? (_openBlock(), _createBlock(AppLoader, {
              key: 0,
              style: loaderStyle
            }))
          : _createCommentVNode("", true),
        _createElementVNode("div", {
          class: "notification-item__colored",
          style: _normalizeStyle({ backgroundColor: getJobStatusBarColor(props.notification.Status) })
        }, null, 4),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            (props.notification.Worker)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: "notification-item__header-worker",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (showUserJobs(props.notification.Worker.Id)))
                }, _toDisplayString(props.notification.Worker.Name), 1))
              : _createCommentVNode("", true),
            (showCreatorName.value)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createElementVNode("div", _hoisted_6, [
                    _createVNode(AppIcon, {
                      name: "chevron-left",
                      width: "16px",
                      color: "#499259"
                    })
                  ]),
                  _createElementVNode("div", {
                    class: "notification-item__header-worker",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (showUserJobs(props.notification?.Creator?.Id)))
                  }, _toDisplayString(props.notification?.Creator?.Name), 1)
                ], 64))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_7, [
            (hasActionButtons.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                  (showSendToChecking.value)
                    ? (_openBlock(), _createBlock(AppTooltip, {
                        key: 0,
                        text: _ctx.$t('job_action_send_to_checking')
                      }, {
                        activator: _withCtx(() => [
                          _createVNode(AppIcon, {
                            class: "notification-item__action-icon--warning",
                            name: "send-to-check",
                            width: "18px",
                            color: "#FEF3D5",
                            cursor: "pointer",
                            onClick: _cache[3] || (_cache[3] = ($event: any) => (startAction('sendToChecking')))
                          })
                        ]),
                        _: 1
                      }, 8, ["text"]))
                    : _createCommentVNode("", true),
                  (showEndByWorkerNoMessage.value)
                    ? (_openBlock(), _createBlock(AppTooltip, {
                        key: 1,
                        text: _ctx.$t('job_action_finish')
                      }, {
                        activator: _withCtx(() => [
                          _createVNode(AppIcon, {
                            class: "notification-item__action-icon--success",
                            name: "job-finish",
                            width: "18px",
                            color: "#D9E7DC",
                            cursor: "pointer",
                            onClick: _cache[4] || (_cache[4] = ($event: any) => (directAction('endByWorker')))
                          })
                        ]),
                        _: 1
                      }, 8, ["text"]))
                    : _createCommentVNode("", true),
                  (showSelfWorkerWithReport.value)
                    ? (_openBlock(), _createBlock(AppTooltip, {
                        key: 2,
                        text: _ctx.$t('job_action_finish_with_report')
                      }, {
                        activator: _withCtx(() => [
                          _createVNode(AppIcon, {
                            class: "notification-item__action-icon--success",
                            name: "job-finish",
                            width: "18px",
                            color: "#D9E7DC",
                            cursor: "pointer",
                            onClick: _cache[5] || (_cache[5] = ($event: any) => (startAction('endByWorker')))
                          })
                        ]),
                        _: 1
                      }, 8, ["text"]))
                    : _createCommentVNode("", true),
                  (showSelfWorkerNoReport.value)
                    ? (_openBlock(), _createBlock(AppTooltip, {
                        key: 3,
                        text: _ctx.$t('job_action_finish')
                      }, {
                        activator: _withCtx(() => [
                          _createVNode(AppIcon, {
                            class: "notification-item__action-icon--success",
                            name: "job-finish",
                            width: "18px",
                            color: "#D9E7DC",
                            cursor: "pointer",
                            onClick: _cache[6] || (_cache[6] = ($event: any) => (directAction('endByWorker')))
                          })
                        ]),
                        _: 1
                      }, 8, ["text"]))
                    : _createCommentVNode("", true),
                  (showCreatorChecking.value)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                        _createVNode(AppTooltip, {
                          text: _ctx.$t('job_action_accept')
                        }, {
                          activator: _withCtx(() => [
                            _createVNode(AppIcon, {
                              class: "notification-item__action-icon--success",
                              name: "job-finish",
                              width: "18px",
                              color: "#D9E7DC",
                              cursor: "pointer",
                              onClick: _cache[7] || (_cache[7] = ($event: any) => (directAction('endByCreator')))
                            })
                          ]),
                          _: 1
                        }, 8, ["text"]),
                        _createVNode(AppTooltip, {
                          text: _ctx.$t('job_action_rework')
                        }, {
                          activator: _withCtx(() => [
                            _createVNode(AppIcon, {
                              class: "notification-item__action-icon--warning",
                              name: "back-to-rework",
                              width: "18px",
                              color: "#FEF3D5",
                              cursor: "pointer",
                              onClick: _cache[8] || (_cache[8] = ($event: any) => (startAction('sendToReworking')))
                            })
                          ]),
                          _: 1
                        }, 8, ["text"])
                      ], 64))
                    : _createCommentVNode("", true),
                  (showAdminEnd.value)
                    ? (_openBlock(), _createBlock(AppTooltip, {
                        key: 5,
                        text: _ctx.$t('job_action_finish_as_admin')
                      }, {
                        activator: _withCtx(() => [
                          _createVNode(AppIcon, {
                            class: "notification-item__action-icon--admin",
                            name: "end-by-admin",
                            width: "18px",
                            color: "#DFE5E8",
                            cursor: "pointer",
                            onClick: handleAdminEnd
                          })
                        ]),
                        _: 1
                      }, 8, ["text"]))
                    : _createCommentVNode("", true),
                  (showAdminEndExtra.value)
                    ? (_openBlock(), _createBlock(AppTooltip, {
                        key: 6,
                        text: _ctx.$t('job_action_finish_as_admin')
                      }, {
                        activator: _withCtx(() => [
                          _createVNode(AppIcon, {
                            class: "notification-item__action-icon--admin",
                            name: "end-by-admin",
                            width: "18px",
                            color: "#DFE5E8",
                            cursor: "pointer",
                            onClick: handleAdminEnd
                          })
                        ]),
                        _: 1
                      }, 8, ["text"]))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true),
            _createVNode(AppTooltip, {
              text: _ctx.$t('job_info_title')
            }, {
              activator: _withCtx(() => [
                _createVNode(AppIcon, {
                  class: "notification-item__info-btn",
                  name: "info-circle-outline",
                  width: "18px",
                  color: "#EAEAEA",
                  cursor: "pointer",
                  onClick: handleShowInfo
                })
              ]),
              _: 1
            }, 8, ["text"])
          ])
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", {
            class: "notification-item__body-message",
            innerHTML: _unref(multilineTextToHtml)(props.notification.Message)
          }, null, 8, _hoisted_10),
          (props.notification.Additions && props.notification.Additions.length >= 2 && !additionsExpanded.value)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "notification-item__additions-collapsed",
                onClick: _cache[9] || (_cache[9] = ($event: any) => (additionsExpanded.value = true))
              }, [
                _createVNode(AppIcon, {
                  name: "plus-circle",
                  width: "16px",
                  color: "#979797",
                  cursor: "pointer"
                }),
                _createElementVNode("span", null, _toDisplayString(_ctx.$tc('job_comments_count', props.notification.Additions.length ?? 0)), 1)
              ]))
            : (props.notification.Additions && props.notification.Additions.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.notification.Additions, (addition) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: addition.Date,
                      class: "notification-item__addition"
                    }, [
                      _createElementVNode("div", _hoisted_12, [
                        _createElementVNode("span", _hoisted_13, _toDisplayString(addition.Username), 1),
                        _createElementVNode("span", _hoisted_14, _toDisplayString(formatDateTime(addition.Date)), 1)
                      ]),
                      _createElementVNode("div", _hoisted_15, [
                        _createElementVNode("b", _hoisted_16, _toDisplayString(addition.Title), 1),
                        _cache[13] || (_cache[13] = _createTextVNode(" ")),
                        _createElementVNode("span", {
                          innerHTML: _unref(multilineTextToHtml)(addition.Message)
                        }, null, 8, _hoisted_17)
                      ])
                    ]))
                  }), 128))
                ]))
              : _createCommentVNode("", true),
          (showCommentInput.value)
            ? (_openBlock(), _createElementBlock("div", {
                key: 2,
                class: "notification-item__comment",
                onKeydown: _withKeys(cancelAction, ["escape"])
              }, [
                _createElementVNode("span", _hoisted_18, _toDisplayString(commentLabel.value), 1),
                _createElementVNode("div", _hoisted_19, [
                  _createVNode(AppCustomTextarea, {
                    ref_key: "$commentTextarea",
                    ref: $commentTextarea,
                    modelValue: commentMessage.value,
                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((commentMessage).value = $event)),
                    placeholder: _ctx.$t('ui_enter_text'),
                    "min-height": 32,
                    "max-height": 200,
                    "auto-focus": true,
                    "new-line-mode": _unref(newLineMode),
                    onEnter: submitAction,
                    onCtrlEnter: submitAction
                  }, null, 8, ["modelValue", "placeholder", "new-line-mode"]),
                  _createVNode(AppTooltip, {
                    text: _ctx.$t('ui_cancel')
                  }, {
                    activator: _withCtx(() => [
                      _createVNode(AppIcon, {
                        name: "close-bold",
                        width: "16px",
                        color: "#979797",
                        "hover-color": "#BA4C4C",
                        cursor: "pointer",
                        onClick: cancelAction
                      })
                    ]),
                    _: 1
                  }, 8, ["text"]),
                  _createVNode(AppTooltip, {
                    text: _ctx.$t(_unref(sendHintKey))
                  }, {
                    activator: _withCtx(() => [
                      _createVNode(AppIcon, {
                        name: "send-message",
                        width: "16px",
                        color: "#979797",
                        "hover-color": "#499259",
                        cursor: "pointer",
                        onClick: submitAction
                      })
                    ]),
                    _: 1
                  }, 8, ["text"])
                ])
              ], 32))
            : _createCommentVNode("", true),
          (props.notification.Project)
            ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                _createElementVNode("span", _hoisted_21, _toDisplayString(_ctx.$t('project_label')) + ": ", 1),
                _createVNode(_component_router_link, {
                  class: "notification-item__body-project-link",
                  to: { path: '/main', query: { page: 'project', id: props.notification.Project.Id } },
                  onClick: _cache[11] || (_cache[11] = ($event: any) => (onEntityLinkClick($event, 'project', props.notification.Project.Id)))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(props.notification.Project.Name), 1)
                  ]),
                  _: 1
                }, 8, ["to"])
              ]))
            : _createCommentVNode("", true),
          (props.notification.Clients && props.notification.Clients.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                _createElementVNode("span", _hoisted_23, _toDisplayString(_ctx.$t(props.notification.Clients.length === 1 ? 'client_label' : 'clients_label')) + ": ", 1),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(displayedClients.value, (client, index) => {
                  return (_openBlock(), _createElementBlock(_Fragment, {
                    key: client.Id
                  }, [
                    _createVNode(_component_router_link, {
                      class: "notification-item__body-project-link",
                      to: { path: '/main', query: { page: 'client', id: client.Id } },
                      onClick: ($event: any) => (onEntityLinkClick($event, 'client', client.Id))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(client.Name), 1)
                      ]),
                      _: 2
                    }, 1032, ["to", "onClick"]),
                    (index + 1 < displayedClients.value.length)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_24, " / "))
                      : _createCommentVNode("", true)
                  ], 64))
                }), 128)),
                (!isClientsExpanded.value && props.notification.Clients.length > 1)
                  ? (_openBlock(), _createElementBlock("span", {
                      key: 0,
                      class: "notification-item__body-project-show-more",
                      onClick: _cache[12] || (_cache[12] = ($event: any) => (isClientsExpanded.value = true))
                    }, _toDisplayString(_ctx.$t('more_count_label', { count: props.notification.Clients.length - 1 })), 1))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_25, [
          _createVNode(AppTooltip, { text: dateTooltip.value }, {
            activator: _withCtx(() => [
              _createElementVNode("div", {
                class: _normalizeClass({
								'notification-item__footer-bottom-date': true,
								'notification-item__footer-bottom-date--lost': props.notification.Lost,
								'notification-item__footer-bottom-date--success': props.notification.Status === _unref(JobStatus).Completed && !props.notification.Lost
							})
              }, [
                (props.notification.ToDoDate)
                  ? (_openBlock(), _createBlock(AppIcon, {
                      key: 0,
                      class: "notification-item__footer-bottom-date-clock",
                      name: "clock",
                      width: "16px"
                    }))
                  : _createCommentVNode("", true),
                (props.notification.ToDoDate)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createTextVNode(_toDisplayString(formatDate(props.notification.ToDoDate)), 1)
                    ], 64))
                  : _createCommentVNode("", true)
              ], 2)
            ]),
            _: 1
          }, 8, ["text"]),
          _createElementVNode("span", _hoisted_26, _toDisplayString(formatTime(props.notification.CreateTime)) + " " + _toDisplayString(formatDate(props.notification.CreateTime)), 1)
        ]),
        (isChecked.value)
          ? (_openBlock(), _createBlock(NotificationUndoOverlay, {
              key: 1,
              ref_key: "$undoOverlay",
              ref: $undoOverlay,
              text: _ctx.$t('notification_moved_to_history'),
              onFinish: onMoveCountdownFinish,
              onCancel: onCancelMove
            }, null, 8, ["text"]))
          : _createCommentVNode("", true)
      ])
    ])
  ], 64))
}
}

})